'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const EventFocusListener = () => {
  const searchParams = useSearchParams();
  const eventId = searchParams.get('eventId');
  useEffect(() => {
    if (!eventId) return;
    let attempt = 0;
    const tryFocusToElement = setInterval(() => {
      const el = document.getElementById(eventId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        const nextSearchParams = new URLSearchParams(searchParams);
        nextSearchParams.delete('eventId');
        history.pushState({}, '', `?${nextSearchParams.toString()}`);
        clearInterval(tryFocusToElement);
      }
      attempt++;
      if (attempt > 3) {
        clearInterval(tryFocusToElement);
      }
    }, 500);
    return () => clearInterval(tryFocusToElement);
  }, [eventId]);
  return null;
};
